import api from '../../../../api';

export interface GroupedPinnedMaterial {
  [moduleId: string]: {
    medialinks: string[];
    whitepages: string[];
    userMaterial: string[];
    slideSets: number[];
  };
}

export interface PinnedMaterial {
  medialinks: string[];
  whitepages: string[];
  userMaterial: string[];
  slideSets: number[];
}

export type PinnedMaterialTypeParam = 'MEDIALINK' | 'WHITEPAGE' | 'USER_MATERIAL' | 'SLIDE_SET';

export async function getPinnedMaterial(moduleId: string, includeSubModules = false): Promise<GroupedPinnedMaterial> {
  const query = new URLSearchParams();
  if (includeSubModules) query.append('includeSubModules', 'true');

  const { data } = await api.get(`/studio/user/modules/${moduleId}/pinned-material?${query}`);
  return data;
}

export async function postPinnedMaterial(
  moduleId: string,
  materialId: string | number,
  materialType: PinnedMaterialTypeParam,
): Promise<void> {
  await api.post(`/studio/user/modules/${moduleId}/pinned-material`, {
    materialType,
    materialId,
  });
}

export async function deletePinnedMaterial(
  moduleId: string,
  materialId: string | number,
  materialType: PinnedMaterialTypeParam,
): Promise<void> {
  await api.delete(`/studio/user/modules/${moduleId}/pinned-material/${materialId}/${materialType}`);
}
